export default function DataGrid() {
	return {
		MuiDataGrid: {
			styleOverrides: {
				root: {
					'& .negative-number': {
						color: 'var(--mui-palette-error-main)',
					},
				},
			},
		},
	}
}
